export default function randomItem(range: number):number {
    return Math.floor(Math.random() * range);
}
